import { useEntityRow } from '@/lib/sync/entity-store';
import type { Access } from '@/lib/sharing/utils/permissions';

/**
 * Returns the Access object for any BaseEntityRow-shaped entity by id
 * (document, collection, canvas, space). Reads via the kind-agnostic
 * `useEntityRow` accessor so adding a new entity kind in the future
 * doesn't require updating this hook.
 *
 * Recordings do not carry an Access row today — they inherit access from
 * their linked document via entityMeta, so callers should pass the
 * recording's entityId, not its recording id.
 *
 * Accepts null/undefined — returns null immediately without querying the
 * store. Returns null when the id doesn't exist in any of the entity maps.
 */
export function useAccess(id: string | null | undefined): Access | null {
  const row = useEntityRow(id);
  return row?.access ?? null;
}
